import url from 'postcss-url';
import Vue from 'vue'
import Router from 'vue-router'
import store from "../store/index";
let index = () => import("@/components/index") //全局


//单商铺
let singleHomePage = () => import('@/components/singleShop/tab/singleHomePage') //首页
let someProduct = () => import('@/components/singleShop/tab/someProduct') //全部商品
let singleSearch = () => import('@/components/singleShop/tab/singleSearch') //搜索商品
//平台
let homePage = () => import('@/components/page/home/homePage') //首页

let column = () => import('@/components/page/column/column') //首页 栏目 
let columnNew = () => import('@/components/page/column/columnNew') //首页 栏目 新课专区
let columnNewPage = () => import('@/components/page/column/newPage') //首页 栏目 新课专区一元秒杀
let columnPromotion = () => import('@/components/page/column/columnPromotion') //首页促销专区

let columnHot = () => import('@/components/page/column/columnHot') //热销榜


let customizedIndex = () => import('@/components/page/customized/index') //首页 栏目 定制专区
let myCustomized = () => import('@/components/page/customized/myCustomized') //我的清单
let customizedDetail = () => import('@/components/page/customized/customizedDetail') //清单列表
let productCustomDetail = () => import('@/components/page/customized/productCustomDetail') //清单列表






let collectCoupons = () => import('@/components/page/coupon/collectCoupons') //领券中心

let classify = () => import('@/components/page/classify/classify') //分类

let classify1 = () => import('@/components/page/classify/classify分类1') //分类


let activity = () => import('@/components/page/activity/activity') //活动
let activityDetails = () => import('@/components/page/activity/activityDetails') //套餐包详情
let shoppingCart = () => import('@/components/page/shoppingCart/shoppingCart') //购物车
let myShop = () => import('@/components/page/myShop/myShop') //我的
let shezhi = () => import('@/components/page/myShop/shezhi') //设置
let help = () => import('@/components/page/myShop/help') //操作手册
let investment = () => import('@/components/page/myShop/investment') //招商
let footprint = () => import('@/components/page/myShop/footprint') //足迹
let login = () => import('@/components/page/login/login') //登录
let register = () => import('@/components/page/login/register') //注册账户
let yinsi = () => import('@/components/page/login/yinsi') //注册账户
let fuwu = () => import('@/components/page/login/fuwu') //注册账户
let forgetPassword = () => import('@/components/page/login/forgetPassword') //忘记密码
let modifyPassword = () => import('@/components/page/login/modifyPassword') //修改密码
let qualification = () => import('@/components/page/login/qualification') //资质信息
let productDetail = () => import('@/components/page/product/productDetail') //商品详情
let newProduct = () => import('@/components/page/product/newProduct') //新品登记
let newShopResgister = () => import('@/components/page/product/newShopResgister') //新品登记
let myOrder = () => import('@/components/page/order/myOrder') //我的订单
let orderDetails = () => import('@/components/page/order/orderDetails') //订单详情
let orderSubmitZJ = () => import('@/components/page/order/orderSubmitZJ') //提交订单  中金

let orderSubmit = () => import('@/components/page/order/orderSubmit') //提交订单  桔合付

let payOffline = () => import('@/components/page/order/payOffline') //线下支付页面


let returnGoods = () => import('@/components/page/order/returnGoods') //退款退货 
let refundDetails = () => import('@/components/page/order/refundDetails') //退款详情 
let logistics = () => import('@/components/page/order/logistics') //查看物流
let ok = () => import('@/components/page/order/ok') //支付成功
// let ok1 = () => import('@/components/page/order/ok1') //支付成功

let evaluate = () => import('@/components/page/order/evaluate') //评价 
let search = () => import('@/components/page/search/search') //搜索
let historySearch = () => import('@/components/page/search/historySearch') //搜索
let address = () => import('@/components/page/address/address') //收货地址 
let increaseAddress = () => import('@/components/page/address/increaseAddress') //新增地址 
let hdong = () => import('@/components/page/hdong/hdong') //中金支付贷款页
let hdongy = () => import('@/components/page/hdong/hdongy') //谦医计划页
let myCoupons = () => import('@/components/page/coupon/myCoupons') //我的优惠券 
let collection = () => import('@/components/page/collection/collection') //我的收藏
let accountAccount = () => import('@/components/page/accountAccount/accountAccount') //个人账户
let bangka = () => import('@/components/page/accountAccount/bangka') //申请绑卡 
let qrbangka = () => import('@/components/page/accountAccount/qrbangka') //确认绑卡 
let photocopy = () => import('@/components/page/accountAccount/photocopy') //采集信息 
let openAccount = () => import('@/components/page/accountAccount/openAccount') //企业绑卡  
let liveBroadcast = () => import('@/components/page/broadcast/liveBroadcast') //直播 
let enterbroadcast = () => import('@/components/page/broadcast/enterbroadcast') //直播 
let a = () => import('@/components/page/broadcast/a') //直播 
let customerService = () => import('@/components/page/customer/customerService') //客户服务
let customer = () => import('@/components/page/customer/customer') //客户服务 
let information = () => import('@/components/page/customer/information') //客户服务

let shop = () => import('@/components/page/shop/shop') //店铺
let allStores = () => import('@/components/page/shop/allStores') //全部  店铺列表 
let historyShop = () => import('@/components/page/shop/historyShop') //全部  店铺历史记录
let searchShop = () => import('@/components/page/shop/searchShop') //全部  店铺搜索
let shopColumn = () => import('@/components/page/shop/shopColumn') //全部  店铺中专区列表



let sales = () => import('@/components/page/sales/sales') //业务员
let news = () => import('@/components/page/new/news') //新闻 
let newDetails = () => import('@/components/page/new/newDetails') //新闻
//-----------------------------------------------------------------------------------
let integralMall = () => import('@/components/page/integralMall/integralMall') //积分签到首页
let integralRecord = () => import('@/components/page/integralMall/integralRecord') //积分兑换记录
let integralRecordQ = () => import('@/components/page/integralMall/integralRecordQ') //积分签到记录
let integralProduct = () => import('@/components/page/integralMall/integralProduct')
let integralAddress = () => import('@/components/page/integralMall/integralAddress') //新增地址 
//---------------------------------------------------------------------------------------
let frame = () => import('@/components/page/frame/frame')
let accountingPeriod = () => import('@/components/page/accountingPeriod/accountingPeriod') //账期资料
let updata = () => import('@/components/page/accountingPeriod/updata') //账期上传
let Xaccounting = () => import('@/components/page/accountingPeriod/Xaccounting') //账期上传
let seckill = () => import('@/components/page/seckill/seckill') //秒杀
let headPortrait = () => import('@/components/page/myShop/headPortrait') //秒杀
let comment = () => import('@/components/page/product/comment') //秒杀
//----------------------------------------------------------------
let home = () => import('@/components/school/home') //商学院
let liveBroadcasts = () => import('@/components/school/broadcast/liveBroadcast') //商学院
let businessSchool = () => import('@/components/school/businessSchool/businessSchool') //商学院
let mySchool = () => import('@/components/school/mySchool/mySchool') //我的学院
let videoList = () => import('@/components/school/videoList/videoList') //我的学院

let videoListM = () => import('@/components/school/videoList/videoListM') //名医讲堂

let iframeVideo = () => import('@/components/school/videoList/iframeVideo') //名医讲堂


let videoClassify = () => import('@/components/school/videoList/videoClassify') //我的学院
let classHour = () => import('@/components/school/classHour/classHour') //视频
let collect = () => import('@/components/school/collect/collect') //视频
let record = () => import('@/components/school/record/record') //视频
let follow = () => import('@/components/school/follow/follow') //视频
let searchs = () => import('@/components/school/search/searchs') //视频
let recommend = () => import('@/components/school/recommend/recommend') //视频
let subscribe = () => import('@/components/school/subscribe/subscribe') //视频
let lecturer = () => import('@/components/school/lecturer/lecturer') //视频
let buy = () => import('@/components/school/buy/buy') //已购视频
//-----------------
let regionalGood = () => import('@/components/page/regionalGood/regionalGood') //视频


// 新增
let find = () => import('@/components/page/find/index') //视频
let findIndex = () => import('@/components/page/find/find') //  发现主页 新

let videoCompent = () => import('@/components/page/find/videoCompent') //  

let findMessage = () => import('@/components/page/find/findMessage') //  
let table = () => import('@/components/page/find/table') //  



let updateSales = () => import('@/components/page/newPage/sales') //更换业务员
let message = () => import('@/components/page/newPage/message') //消息通知
let messageDetail = () => import('@/components/page/newPage/messageDetail') //消息通知
let article = () => import('@/components/school/videoList/article') //消息通知
let regionalGoodDetail = () => import('@/components/page/regionalGood/regionalGoodDetail') //品牌专区详情
let messageQu = () => import('@/components/page/shop/message') //品牌专区详情
let activeWeek = () => import('@/components/page/newPage/activeWeek') //秒杀

let wareHouse = () => import('@/components/page/newPage/wareHouse') //中央仓首页
let wareProcure = () => import('@/components/page/newPage/wareProcure') //采购需求
let wareAdd = () => import('@/components/page/newPage/wareAdd') //发布商品
let wareDetail = () => import('@/components/page/newPage/wareDetail') //详情
let wareProDetail = () => import('@/components/page/newPage/wareProDetail') //需求详情
let wareHouseDetail = () => import('@/components/page/newPage/wareHouseDetail') //
let wareInfo = () => import('@/components/page/newPage/wareInfo') //资讯
let wareMy = () => import('@/components/page/newPage/wareMy') //我的
let wareMyDetail = () => import('@/components/page/newPage/wareMyDetail') //列表

let demo1 = () => import('@/components/page/shoppingCart/demo') //列表

let indexWH = () => import('@/components/page/login/indexWH') //维护页面
let integralLogistics = () => import('@/components/page/integralMall/integralLogistics') //查看物流 


let feedback = () => import('@/components/page/myShop/feedback') //问题反馈
let feedlist = () => import('@/components/page/myShop/feedlist') //问题反馈列表

let returnGoodsRules = () => import('@/components/page/myShop/returnGoodsRules') //退换货规则

let vipmessage = () => import('@/components/page/myShop/vipmessage') //会员权益

// 原药材
let originalhome = () => import('@/components/originalmedicinal/originalhome') //我的 原药材
let originalindex = () => import('@/components/originalmedicinal/originindex/originindex') //首页
// let issue = () => import('@/components/originalmedicinal/issue/issue') //发布
let myoriginal = () => import('@/components/originalmedicinal/myoriginal/myoriginal') //我的

let supplycount = () => import('@/components/originalmedicinal/originindex/supplycount') //供应信息
let issueproduct = () => import('@/components/originalmedicinal/issue/issueproduct') //发布商品
let issuseBuy = () => import('@/components/originalmedicinal/issue/issuseBuy') //发布商品
let myMessage = () => import('@/components/originalmedicinal/myoriginal/myMessage') //我的消息
let myask = () => import('@/components/originalmedicinal/myoriginal/myask') //我的留言
let myopinion = () => import('@/components/originalmedicinal/myoriginal/myopinion') //意见反馈
let mypurchaser = () => import('@/components/originalmedicinal/myoriginal/mypurchaser') //采购商认证
let originalproductdetail = () => import('@/components/originalmedicinal/originindex/productdetail') //商品详情
let myrelease = () => import('@/components/originalmedicinal/myoriginal/myrelease') //我的发布
let myShopName = () => import('@/components/originalmedicinal/myoriginal/myShopName') //我的发布
let identification = () => import('@/components/originalmedicinal/originindex/identification') //认证
let productHouse = () => import('@/components/originalmedicinal/myoriginal/productHouse') //入库
let productHousedemo = () => import('@/components/originalmedicinal/myoriginal/productHousedemo') //入库
let inspection = () => import('@/components/originalmedicinal/originindex/inspection') //三方质检
let xy = () => import('@/components/originalmedicinal/myoriginal/xy') //三方质检

let updatePhone = () => import('@/components/page/login/updatePhone') //收货地址 






const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
	if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
	return originalPush.call(this, location).catch(err => err)
}
const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
	return originalReplace.call(this, location).catch(err => err);
};


Vue.use(Router)

const router = new Router({
	routes: [{
			path: "*",
			name: "NotFount",
			component: () => import("@/components/NotFount.vue"),
		},
		{
			path: '/',
			name: 'index',
			component: index,
			meta: {
				title: "药采够商城",
				keepAlive: false // 需要缓存
			},
			children: [{
					path: '',
					name: 'homePage',
					component: homePage,
					meta: {
						title: "药采够-首页",
						keepAlive: true // 需要缓存
					},
				}, {
					path: '/classify',
					name: 'classify',
					component: classify,
					meta: {
						title: "分类",
						keepAlive: true // 需要缓存
					},
				}, {
					path: '/activity',
					name: 'activity',
					component: activity,
					meta: {
						title: "活动",
						keepAlive: true // 需要缓存
					},
				}, {
					path: '/shoppingCart',
					name: 'shoppingCart',
					component: shoppingCart,
					meta: {
						title: "购物车",
						keepAlive: true // 需要缓存
					},
				},
				{
					path: '/demo1',
					name: 'demo1',
					component: demo1,
					meta: {
						title: "购物车",
						keepAlive: true // 需要缓存
					},
				},
				{
					path: '/myShop',
					name: 'myShop',
					component: myShop,
					meta: {
						title: "个人中心",
						keepAlive: true // 需要缓存
					},
				}, 
				{
					path: '/findIndex',
					name: 'findIndex',
					component: findIndex,
					meta: {
						title: "发现",
						keepAlive: true // 需要缓存
					},
				},
				{
					path: '/find',
					name: 'find',
					component: find,
					meta: {
						title: "发现",
						keepAlive: false // 需要缓存
					},
				},
				
				
				
				{
					path: '/singleHomePage',
					name: 'singleHomePage',
					component: singleHomePage,
					meta: {
						title: "首页",
					},
				}, {
					path: '/someProduct',
					name: 'someProduct',
					component: someProduct,
					meta: {
						title: "全部商品",
					},
				},
				// {
				//      path: '/integralMall',
				//      name: 'integralMall',
				//      component: integralMall,
				//      meta: {
				//        title: "积分商城",
				//        keepAlive: false // 需要缓存
				//      },
				//    },
				]
		}, {
			path: '/a',
			name: 'a',
			component: a,
			meta: {
				title: "加载中...",
				keepAlive: false // 需要缓存
			},
		},

		// {
		//   path: '/demo',
		//   name: 'demo',
		//   component: demo,
		//   meta: {
		//     title: "加载中...",
		//     keepAlive: false // 需要缓存
		//   },
		// },

		{
			path: '/integralMall',
			name: 'integralMall',
			component: integralMall,
			meta: {
				title: "积分商城",
				keepAlive: false // 需要缓存
			},
		},

		{
			path: '/seckill',
			name: 'seckill',
			component: seckill,
			meta: {
				title: "超级秒杀",
				keepAlive: false // 需要缓存
			},
		}, {
			path: '/activeWeek',
			name: 'activeWeek',
			component: activeWeek,
			meta: {
				title: "天天特卖",
				keepAlive: false // 需要缓存
			},
		},
		{
			path: '/wareHouse',
			name: 'wareHouse',
			component: wareHouse,
			meta: {
				title: "中央仓",
				keepAlive: false // 需要缓存
			},
		},
		{
			path: '/wareProcure',
			name: 'wareProcure',
			component: wareProcure,
			meta: {
				title: "采购需求",
				keepAlive: false // 需要缓存
			},
		},
		{
			path: '/wareProDetail',
			name: 'wareProDetail',
			component: wareProDetail,
			meta: {
				title: "需求详情",
				keepAlive: false // 需要缓存
			},
		},
		{
			path: '/wareHouseDetail',
			name: 'wareHouseDetail',
			component: wareHouseDetail,
			meta: {
				title: "原药材详情",
				keepAlive: false // 需要缓存
			},
		},


		{
			path: '/wareAdd',
			name: 'wareAdd',
			component: wareAdd,
			meta: {
				title: "发布商品",
				keepAlive: false // 需要缓存
			},
		},
		{
			path: '/wareDetail',
			name: 'wareDetail',
			component: wareDetail,
			meta: {
				title: "商品详情",
				keepAlive: false // 需要缓存
			},
		},
		{
			path: '/wareInfo',
			name: 'wareInfo',
			component: wareInfo,
			meta: {
				title: "资讯详情",
				keepAlive: false // 需要缓存
			},
		},
		{
			path: '/wareMy',
			name: 'wareMy',
			component: wareMy,
			meta: {
				title: "列表",
				keepAlive: false // 需要缓存
			},
		},
		{
			path: '/wareMyDetail',
			name: 'wareMyDetail',
			component: wareMyDetail,
			meta: {
				title: "列表",
				keepAlive: false // 需要缓存
			},
		},
		{
			path: '/productDetail',
			name: 'productDetail',
			component: productDetail,
			meta: {
				title: "商品详情",
				keepAlive: false // 需要缓存
			},
		}, {
			path: '/comment',
			name: 'comment',
			component: comment,
			meta: {
				title: "商品评价",
				keepAlive: false // 需要缓存
			},
		}, {
			path: '/newProduct',
			name: 'newProduct',
			component: newProduct,
			meta: {
				title: "新品登记",
				keepAlive: false // 需要缓存
			},
		},
		{
			path: '/login',
			name: 'login',
			component: login,
			meta: {
				title: "登录",
				keepAlive: false // 需要缓存
			},
		},
		{
			path: '/indexWH',
			name: 'indexWH',
			component: indexWH,
			meta: {
				title: "维护",
				keepAlive: false // 需要缓存
			},
		},

		{
			path: '/register',
			name: 'register',
			component: register,
			meta: {
				title: "注册账户",
				keepAlive: false // 需要缓存
			},
		}, {
			path: '/qualification',
			name: 'qualification',
			component: qualification,
			meta: {
				title: "资质信息",
				keepAlive: false // 需要缓存
			},
		},
		{
			path: '/myOrder',
			name: 'myOrder',
			component: myOrder,
			meta: {
				title: "我的订单",
				keepAlive: false // 需要缓存
			},
		},
		{
			path: '/orderDetails',
			name: 'orderDetails',
			component: orderDetails,
			meta: {
				title: "订单详情",
				keepAlive: false // 需要缓存
			},
		},
		{
			path: '/orderSubmit',
			name: 'orderSubmit',
			component: orderSubmit,
			meta: {
				title: "提交订单",
				keepAlive: false // 需要缓存 
			},
		},


		{
			path: '/orderSubmitZJ',  //中金的支付
			name: 'orderSubmitZJ',
			component: orderSubmitZJ,
			meta: {
				title: "提交订单",
				keepAlive: false // 需要缓存 
			},
		},
		
		{
			path: '/payOffline',  //中金的支付
			name: 'payOffline',
			component: payOffline,
			meta: {
				title: "线下支付",
				keepAlive: false // 需要缓存 
			},
		},
		
		




		{
			path: '/returnGoods',
			name: 'returnGoods',
			component: returnGoods,
			meta: {
				title: "申请退款",
				keepAlive: false // 需要缓存
			},
		}, {
			path: '/refundDetails',
			name: 'refundDetails',
			component: refundDetails,
			meta: {
				title: "退款详情",
				keepAlive: false // 需要缓存 evaluate
			},
		}, {
			path: '/logistics',
			name: 'logistics',
			component: logistics,
			meta: {
				title: "查看物流",
				keepAlive: false // 需要缓存 evaluate
			},
		}, {
			path: '/integralLogistics',
			name: 'integralLogistics',
			component: integralLogistics,
			meta: {
				title: "查看物流",
				keepAlive: false // 需要缓存 evaluate
			},
		},
		{
			path: '/evaluate',
			name: 'evaluate',
			component: evaluate,
			meta: {
				title: "评价",
				keepAlive: false // 需要缓存 
			},
		}, {
			path: '/ok',
			name: 'ok',
			component: ok,
			meta: {
				title: "药采够商城",
				keepAlive: false // 需要缓存 
			},
		},
		// {
		// 	path: '/ok1',
		// 	name: 'ok1',
		// 	component: ok1,
		// 	meta: {
		// 		title: "药采够商城",
		// 		keepAlive: false // 需要缓存 
		// 	},
		// },
		{
			path: '/address',
			name: 'address',
			component: address,
			meta: {
				title: "收货地址",
				keepAlive: false // 需要缓存
			},
		},
		{
			path: '/updatePhone',
			name: 'updatePhone',
			component: updatePhone,
			meta: {
				title: "更换手机号",
				keepAlive: false // 需要缓存
			},
		},
		{
			path: '/increaseAddress',
			name: 'increaseAddress',
			component: increaseAddress,
			meta: {
				title: "",
				keepAlive: false // 需要缓存
			},
		},
		{
			path: '/integralAddress',
			name: 'integralAddress',
			component: integralAddress,
			meta: {
				title: "",
				keepAlive: false // 需要缓存
			},
		},

		{
			path: '/search',
			name: 'search',
			component: search,
			meta: {
				title: "药采够商城",
				keepAlive: true // 需要缓存
			},
		}, {
			path: '/historySearch',
			name: 'historySearch',
			component: historySearch,
			meta: {
				title: "药采够商城",
				keepAlive: false // 需要缓存
			},
		},
		{
			path: '/hdong',
			name: 'hdong',
			component: hdong,
			meta: {
				title: "药采够商城",
				keepAlive: false // 需要缓存
			},
		},
		{
			path: '/hdongy',
			name: 'hdongy',
			component: hdongy,
			meta: {
				title: "药采够商城",
				keepAlive: false // 需要缓存
			},
		},{
			path: '/vipmessage',
			name: 'vipmessage',
			component: vipmessage,
			meta: {
				title: "会员介绍",
				keepAlive: false // 需要缓存
			},
		},
		{
			path: '/collectCoupons',
			name: 'collectCoupons',
			component: collectCoupons,
			meta: {
				title: "药采够商城",
				keepAlive: false // 需要缓存
			},
		},
		{
			path: '/returnGoodsRules',
			name: 'returnGoodsRules',
			component: returnGoodsRules,
			meta: {
				title: "药采够商城",
				keepAlive: false // 需要缓存
			},
		},
		{
			path: '/column',
			name: 'column',
			component: column,
			meta: {
				title: "药采够商城", //栏目
				keepAlive: true // 需要缓存
			},
		},
		{
			path: '/columnPromotion',
			name: 'columnPromotion',
			component: columnPromotion,
			meta: {
				title: "药采够商城", //栏目
				keepAlive: true // 需要缓存
			},
		},
		{
			path: '/columnHot',
			name: 'columnHot',
			component: columnHot,
			meta: {
				title: "药采够商城", //栏目
				keepAlive: true // 需要缓存
			},
		},
		


		{
			path: '/columnNew',
			name: 'columnNew',
			component: columnNew,
			meta: {
				title: "药采够商城", //栏目
				keepAlive: true // 需要缓存
			},
		},
		{
			path: '/columnNewPage',
			name: 'columnNewPage',
			component: columnNewPage,
			meta: {
				title: "药采够商城", //栏目
				keepAlive: true // 需要缓存
			},
		},

		{
			path: '/customizedIndex',
			name: 'customizedIndex',
			component: customizedIndex,
			meta: {
				title: "定制专区", //栏目
				keepAlive: true // 需要缓存
			},
		},

		{
			path: '/myCustomized',
			name: 'myCustomized',
			component: myCustomized,
			meta: {
				title: "我的清单", //栏目
				keepAlive: false // 需要缓存
			},
		},

		{
			path: '/customizedDetail',
			name: 'customizedDetail',
			component: customizedDetail,
			meta: {
				title: "清单列表", //栏目
				keepAlive: false // 需要缓存
			},
		},

		{
			path: '/productCustomDetail',
			name: 'productCustomDetail',
			component: productCustomDetail,
			meta: {
				title: "商品详情", //栏目
				keepAlive: false // 需要缓存
			},
		},





		{
			path: '/myCoupons',
			name: 'myCoupons',
			component: myCoupons,
			meta: {
				title: "优惠券",
				keepAlive: false // 需要缓存
			},
		},
		{
			path: '/collection',
			name: 'collection',
			component: collection,
			meta: {
				title: "药采够商城",
				keepAlive: false // 需要缓存
			},
		},
		{
			path: '/accountAccount',
			name: 'accountAccount',
			component: accountAccount,
			meta: {
				title: "个人账户",
				keepAlive: false // 需要缓存 
			},
		},
		{
			path: '/bangka',
			name: 'bangka',
			component: bangka,
			meta: {
				title: "申请绑卡",
				keepAlive: false // 需要缓存 
			},
		}, {
			path: '/qrbangka',
			name: 'qrbangka',
			component: qrbangka,
			meta: {
				title: "绑卡确认",
				keepAlive: false // 需要缓存 
			},
		},
		{
			path: '/photocopy',
			name: 'photocopy',
			component: photocopy,
			meta: {
				title: "采集信息",
				keepAlive: false // 需要缓存 
			},
		}, {
			path: '/openAccount',
			name: 'openAccount',
			component: openAccount,
			meta: {
				title: "企业绑卡",
				keepAlive: false // 需要缓存 
			},
		},
		{
			path: '/liveBroadcast',
			name: 'liveBroadcast',
			component: liveBroadcast,
			meta: {
				title: "直播",
				keepAlive: false // 需要缓存
			},
		},
		{
			path: '/enterbroadcast',
			name: 'enterbroadcast',
			component: enterbroadcast,
			meta: {
				title: "直播间",
				keepAlive: false // 需要缓存
			},
		},
		{
			path: '/customerService',
			name: 'customerService',
			component: customerService,
			meta: {
				title: "",
				keepAlive: false // 需要缓存
			},
		},
		{
			path: '/customer',
			name: 'customer',
			component: customer,
			meta: {
				title: "客户服务",
				keepAlive: false // 需要缓存
			},
		}, {
			path: '/information',
			name: 'information',
			component: information,
			meta: {
				title: "消息",
				keepAlive: false // 需要缓存
			},
		},
		{
			path: '/shop',
			name: 'shop',
			component: shop,
			meta: {
				title: "店铺",
				keepAlive: true // 需要缓存
			},
		},
		{
			path: '/allStores',
			name: 'allStores',
			component: allStores,
			meta: {
				title: "店铺",
				keepAlive: false // 需要缓存queryActivity
			},
		},
		{
			path: '/historyShop',
			name: 'historyShop',
			component: historyShop,
			meta: {
				title: "搜索",
				keepAlive: false // 需要缓存queryActivity
			},
		}, {
			path: '/searchShop',
			name: 'searchShop',
			component: searchShop,
			meta: {
				title: "搜索",
				keepAlive: true // 需要缓存queryActivity
			},
		}, {
			path: '/shopColumn',
			name: 'shopColumn',
			component: shopColumn,
			meta: {
				title: "",
				keepAlive: true // 需要缓存queryActivity
			},
		},
		{
			path: '/activityDetails',
			name: 'activityDetails',
			component: activityDetails,
			meta: {
				title: "药采够商城",
				keepAlive: false // 需要缓存
			},
		},
		{
			path: '/sales',
			name: 'sales',
			component: sales,
			meta: {
				title: "业务员",
				keepAlive: false // 需要缓存
			},
		},
		{
			path: '/newShopResgister',
			name: 'newShopResgister',
			component: newShopResgister,
			meta: {
				title: "新品登记",
				keepAlive: false // 需要缓存
			},
		},
		{
			path: '/shezhi',
			name: 'shezhi',
			component: shezhi,
			meta: {
				title: "设置",
				keepAlive: false // 需要缓存
			},
		},
		{
			path: '/feedback',
			name: 'feedback',
			component: feedback,
			meta: {
				title: "问题反馈",
				keepAlive: false // 
			},
		},
		{
			path: '/feedlist',
			name: 'feedlist',
			component: feedlist,
			meta: {
				title: "历史反馈",
				keepAlive: false // 
			},
		},

		{
			path: '/help',
			name: 'help',
			component: help,
			meta: {
				title: "操作手册",
				keepAlive: false // 需要缓存
			},
		}, {
			path: '/headPortrait',
			name: 'headPortrait',
			component: headPortrait,
			meta: {
				title: "头像上传",
				keepAlive: false // 需要缓存
			},
		},
		{
			path: '/footprint',
			name: 'footprint',
			component: footprint,
			meta: {
				title: "足迹",
				keepAlive: false // 需要缓存
			},
		}, {
			path: '/investment',
			name: 'investment',
			component: investment,
			meta: {
				title: "药采够商城",
				keepAlive: false // 需要缓存
			},
		},
		{
			path: '/yinsi',
			name: 'yinsi',
			component: yinsi,
			meta: {
				title: "隐私政策",
				keepAlive: false // 需要缓存
			},
		}, {
			path: '/fuwu',
			name: 'fuwu',
			component: fuwu,
			meta: {
				title: "服务协议",
				keepAlive: false // 需要缓存
			},
		}, {
			path: '/forgetPassword',
			name: 'forgetPassword',
			component: forgetPassword,
			meta: {
				title: "忘记密码",
				keepAlive: false // 需要缓存
			},
		},
		{
			path: '/modifyPassword',
			name: 'modifyPassword',
			component: modifyPassword,
			meta: {
				title: "修改密码",
				keepAlive: false // 需要缓存
			},
		},
		{
			path: '/news',
			name: 'news',
			component: news,
			meta: {
				title: "新闻",
				keepAlive: false // 需要缓存
			},
		},
		{
			path: '/newDetails',
			name: 'newDetails',
			component: newDetails,
			meta: {
				title: "新闻",
				keepAlive: false // 需要缓存
			},
		},
		{
			path: '/integralRecord',
			name: 'integralRecord',
			component: integralRecord,
			meta: {
				title: "积分商城",
				keepAlive: false // 需要缓存
			},
		},
		{
			path: '/integralRecordQ',
			name: 'integralRecordQ',
			component: integralRecordQ,
			meta: {
				title: "积分商城",
				keepAlive: false // 需要缓存
			},
		},

		{
			path: '/integralProduct',
			name: 'integralProduct',
			component: integralProduct,
			meta: {
				title: "商品详情",
				keepAlive: false // 需要缓存
			},
		},
		{
			path: '/frame',
			name: 'frame',
			component: frame,
			meta: {
				title: "",
				keepAlive: false // 需要缓存
			},
		}, {
			path: '/accountingPeriod',
			name: 'accountingPeriod',
			component: accountingPeriod,
			meta: {
				title: "账期资料",
				keepAlive: false // 需要缓存
			},
		}, {
			path: '/updata',
			name: 'updata',
			component: updata,
			meta: {
				title: "账期上传",
				keepAlive: false // 需要缓存
			},
		}, {
			path: '/Xaccounting',
			name: 'Xaccounting',
			component: Xaccounting,
			meta: {
				title: "账期上传",
				keepAlive: false // 需要缓存
			},
		}, {
			path: '/regionalGood',
			name: 'regionalGood',
			component: regionalGood,
			meta: {
				title: "区域专区",
				keepAlive: true // 需要缓存
			},
		},
		
		
		{
			path: '/originalhome',
			name: 'originalhome',
			component: originalhome,
			meta: {
				title: "原药材",
				keepAlive: false, // 需要缓存
			},
			children: [
				{
					path: '',
					name: 'originalindex',
					component: originalindex,
					meta: {
						title: "首页",
						keepAlive: false // 需要缓存
					},
				}, 
				
				// {
				// 	path: '/issue',
				// 	name: 'issue',
				// 	component: issue,
				// 	meta: {
				// 		title: "发布",
				// 		keepAlive: false // 需要缓存
				// 	},
				// }, 
				
			{
				path: '/myoriginal',
				name: 'myoriginal',
				component: myoriginal,
				meta: {
					title: "个人中心",
					keepAlive: false // 需要缓存
				},
			}]
		}, 
		{
			path: '/supplycount',
			name: 'supplycount',
			component: supplycount,
			meta: {
				title: "供应信息",
				keepAlive: false // 需要缓存
			},
		},
		{
			path: '/issueproduct',
			name: 'issueproduct',
			component: issueproduct,
			meta: {
				title: "发布商品",
				keepAlive: false // 需要缓存
			},
		},
		{
			path: '/issuseBuy',
			name: 'issuseBuy',
			component: issuseBuy,
			meta: {
				title: "发布采购",
				keepAlive: false // 需要缓存
			},
		},
		{
			path: '/myMessage',
			name: 'myMessage',
			component: myMessage,
			meta: {
				title: "我的消息",
				keepAlive: false // 需要缓存
			},
		},
		{
			path: '/myask',
			name: 'myask',
			component: myask,
			meta: {
				title: "我的留言",
				keepAlive: false // 需要缓存
			},
		},
		{
			path: '/myopinion',
			name: 'myopinion',
			component: myopinion,
			meta: {
				title: "意见反馈",
				keepAlive: false // 需要缓存
			},
		},
		{
			path: '/mypurchaser',
			name: 'mypurchaser',
			component: mypurchaser,
			meta: {
				title: "采购商认证",
				keepAlive: false // 需要缓存
			},
		},
		{
			path: '/originalproductdetail',
			name: 'originalproductdetail',
			component: originalproductdetail,
			meta: {
				title: "商品详情",
				keepAlive: false // 需要缓存
			},
		},
		{
			path: '/myrelease',
			name: 'myrelease',
			component: myrelease,
			meta: {
				title: "我的发布",
				keepAlive: false // 需要缓存
			},
		},
		{
			path: '/myShopName',
			name: 'myShopName',
			component: myShopName,
			meta: {
				title: "店铺详情",
				keepAlive: false // 需要缓存
			},
		},
		{
			path: '/identification',
			name: 'identification',
			component: identification,
			meta: {
				title: "认证",
				keepAlive: false // 需要缓存
			},
		},
		{
			path: '/productHouse',
			name: 'productHouse',
			component: productHouse,
			meta: {
				title: "入库",
				keepAlive: false // 需要缓存
			},
		},
		{
			path: '/productHousedemo',
			name: 'productHousedemo',
			component: productHousedemo,
			meta: {
				title: "入库",
				keepAlive: false // 需要缓存
			},
		},
		{
			path: '/inspection',
			name: 'inspection',
			component: inspection,
			meta: {
				title: "三方质检",
				keepAlive: false // 需要缓存
			},
		},
		
		{
			path: '/xy',
			name: 'xy',
			component: xy,
			meta: {
				title: "三方质检",
				keepAlive: false // 需要缓存
			},
		},
		
		
		
		
		
		
		
		
		
		{
			path: '/home',
			name: 'home',
			component: home,
			meta: {
				title: "商学院",
				keepAlive: false, // 需要缓存
			},
			children: [{
				path: '',
				name: 'businessSchool',
				component: businessSchool,
				meta: {
					title: "首页",
					keepAlive: false // 需要缓存
				},
			}, {
				path: '/liveBroadcasts',
				name: 'liveBroadcasts',
				component: liveBroadcasts,
				meta: {
					title: "直播",
					keepAlive: false // 需要缓存
				},
			}, {
				path: '/mySchool',
				name: 'mySchool',
				component: mySchool,
				meta: {
					title: "个人中心",
					keepAlive: false // 需要缓存
				},
			}, ]
		}, {
			path: '/videoList',
			name: 'videoList',
			component: videoList,
			meta: {
				// title: "",  //原版
				title: "营销干货", //改后
				keepAlive: false // 需要缓存
			},
		}, {
			path: '/videoListM', //中药学习
			name: 'videoListM',
			component: videoListM,
			meta: {
				title: "",
				keepAlive: false // 需要缓存
			},
		},
		
		{
			path: '/videoCompent',
			name: 'videoCompent',
			component: videoCompent,
			meta: {
				title: "发现",
				keepAlive: false // 需要缓存
			},
		},
		
		{
			path: '/findMessage',
			name: 'findMessage',
			component: findMessage,
			meta: {
				title: "发现",
				keepAlive: false // 需要缓存
			},
		},
		
		{
			path: '/table',
			name: 'table',
			component: table,
			meta: {
				title: "详情",
				keepAlive: false // 需要缓存
			},
		},
		
		
		
		// {
		//   path: '/iframeVideo',   //中药学习
		//   name: 'iframeVideo',
		//   component: iframeVideo,
		//   meta: {
		//     title: "",
		//     keepAlive: false // 需要缓存
		//   },
		// },


		{
			path: '/videoClassify',
			name: 'videoClassify',
			component: videoClassify,
			meta: {
				title: "",
				keepAlive: true // 需要缓存
			},
		}, {
			path: '/classHour',
			name: 'classHour',
			component: classHour,
			meta: {
				// title: "", // 原
				title: "详情",
				keepAlive: false // 需要缓存
			},
		}, {
			path: '/collect',
			name: 'collect',
			component: collect,
			meta: {
				title: "收藏",
				keepAlive: false // 需要缓存
			},
		}, {
			path: '/record',
			name: 'record',
			component: record,
			meta: {
				title: "记录",
				keepAlive: false // 需要缓存
			},
		}, {
			path: '/follow',
			name: 'follow',
			component: follow,
			meta: {
				title: "关注",
				keepAlive: false // 需要缓存
			},
		}, {
			path: '/searchs',
			name: 'searchs',
			component: searchs,
			meta: {
				title: "搜索视频",
				keepAlive: false // 需要缓存
			},
		}, {
			path: '/recommend',
			name: 'recommend',
			component: recommend,
			meta: {
				title: "",
				keepAlive: false // 需要缓存
			},
		}, {
			path: '/subscribe',
			name: 'subscribe',
			component: subscribe,
			meta: {
				title: "订阅",
				keepAlive: false // 需要缓存
			},
		}, {
			path: '/lecturer',
			name: 'lecturer',
			component: lecturer,
			meta: {
				title: "讲师主页",
				keepAlive: false // 需要缓存
			},
		}, {
			path: '/buy',
			name: 'buy',
			component: buy,
			meta: {
				title: "已购",
				keepAlive: false // 需要缓存
			},
		}, {
			path: '/singleSearch',
			name: 'singleSearch',
			component: singleSearch,
			meta: {
				title: "搜索",
				keepAlive: true // 需要缓存
			},
		}, {
			path: '/updateSales',
			name: 'updateSales',
			component: updateSales,
			meta: {
				title: "更换业务员",
				keepAlive: false // 需要缓存
			},
		}, {
			path: '/message',
			name: 'message',
			component: message,
			meta: {
				title: "消息通知",
				keepAlive: false // 需要缓存
			},
		},
		{
			path: '/messageDetail',
			name: 'messageDetail',
			component: messageDetail,
			meta: {
				title: "通知详情",
				keepAlive: false // 需要缓存
			},
		},
		{
			path: '/article',
			name: 'article',
			component: article,
			meta: {
				title: "详情",
				keepAlive: false // 需要缓存
			},
		},
		{
			path: '/regionalGoodDetail',
			name: 'regionalGoodDetail',
			component: regionalGoodDetail,
			meta: {
				title: "详情",
				keepAlive: false // 需要缓存
			},
		},
		{
			path: '/messageQu',
			name: 'messageQu',
			component: messageQu,
			meta: {
				title: "资质信息",
				keepAlive: false // 需要缓存
			},
		},

	]
})
router.beforeEach((to, from, next) => {
	store.commit("tabs", {
		key: "to",
		value: to
	})
	store.commit("tabs", {
		key: "from",
		value: from
	})
	if (to.name === "shoppingCart" || to.name === "myShop") {
		if (JSON.parse(localStorage.getItem("userInfo")) != null) {
			next()
		} else {
			router.push(`/login`)
			next();
		}
	} else {
		next();
	}

})
export default router


// WEBPACK FOOTER //
// ./src/router/index.js